export default __webpack_public_path__ + "static/avatar-3@2x-9556b464ce9b4f3aee427bd5ff1b69b1.jpg";